import { render, staticRenderFns } from "./beforeQuestion.vue?vue&type=template&id=16856f5d&"
import script from "./beforeQuestion.vue?vue&type=script&lang=js&"
export * from "./beforeQuestion.vue?vue&type=script&lang=js&"
import style0 from "./beforeQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports